import { SocketLobbySend } from '../socket/SocketLobbySend.ts';
import { UIUtilsNotifications } from './UIUtilsNotifications.ts';
import { socket } from '../EntryShared.ts';
export class UINotificationSendHelper {
    static init() {
        socket.controller.registerSessionEstablishedObserver(()=>{
            this.registerToNotificationServiceAndGetNotifications();
        });
    }
    static registerToNotificationServiceAndGetNotifications() {
        SocketLobbySend.registerToNotificationService();
        UIUtilsNotifications.delayNotificationDataRequest(()=>this.getNotifications());
    }
    static getNotifications() {
        const getNotificationsData = {
            date: new Date(),
            notificationCountToSend: this.INITIAL_NOTIFICATION_COUNT
        };
        SocketLobbySend.getNotifications(getNotificationsData);
    }
    static sendMarkNotificationAsRead(notificationId) {
        SocketLobbySend.markNotificationAsRead(notificationId);
    }
    static sendMarkAllNotificationsAsRead() {
        SocketLobbySend.markAllNotificationsAsRead();
    }
    static getNotificationsAfterDate(date) {
        const getNotificationsData = {
            date: date,
            notificationCountToSend: this.LAZY_LOAD_NOTIFICATION_COUNT
        };
        SocketLobbySend.getNotifications(getNotificationsData);
    }
}
UINotificationSendHelper.INITIAL_NOTIFICATION_COUNT = 25;
UINotificationSendHelper.LAZY_LOAD_NOTIFICATION_COUNT = 10;
